import { Key } from 'react';

export const isSameSet = <T>(set1: Set<T>, set2: Set<T>): boolean =>
  set1.size === set2.size && [...set1].every((x) => set2.has(x));

export const isSameSelection = (
  sel1: Iterable<Key> | null,
  sel2: Iterable<Key> | null
): boolean =>
  sel1 !== 'all' && sel1 !== null && sel2 !== 'all' && sel2 !== null
    ? isSameSet(new Set(sel1), new Set(sel2))
    : sel1 !== sel2;
